import { LOAD_THEMES_SETTINGS } from '../actionType';

const commonReducer = (state: any, action: any) => {
  switch (action.type) {
    case LOAD_THEMES_SETTINGS:
      return {
        ...state,
        themesInfo: action.payload,
      };
    default:
      return state;
  }
};

export default commonReducer;
